/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2023, Zumper
 */

import type { AutocompleteApiResult } from '@zcode/bizos'
import { AUTOCOMPLETE_CITY } from '../constants'

export const getPredictionText = (predictionResult: AutocompleteApiResult, searchTerm: string) => {
  const { city, name, state, type } = predictionResult
  let primaryText = ''

  const isCityType = type === AUTOCOMPLETE_CITY

  if (isCityType) {
    primaryText = `${name}, ${state}`
  } else {
    primaryText = `${name}, ${city && `${city}, `} ${state}`
  }
  const formattedPrimaryText = primaryText.toLowerCase().split(',').join('')
  if (!formattedPrimaryText.includes(searchTerm)) {
    return ''
  }
  const indexOfSearchTerm = formattedPrimaryText.indexOf(searchTerm)
  // remove the words before the search term
  if (indexOfSearchTerm >= 0) {
    primaryText = primaryText.substring(indexOfSearchTerm)
  }

  return primaryText
}
